import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

import error404 from '../assets/error_404.png';


import '../utils/general.css';
import '../utils/error404.css';

export default function Error404() {
  return (
    <Container className='ps-404' fluid>
      <Row>
        <Col className='text-center pt-5'>
          <h1>Are you lost?</h1>
          <Image src={error404} roundedCircle />
          <p>Error 404</p>
        </Col>
      </Row>
    </Container>
  );
}
